<template><div><dt-stack gap="600" class="d-mbs-600">
  <svg-loader name="logo--negative-space" class="d-bar-500" />
  <div>
<h2 class="d-docsite--header-3">the Spark</h2>
<p class="d-docsite--paragraph">The Dialpad icon draws on the core of the Dialpad product, the phone Dialpad and the artificial intelligence that powers our platform.</p>
<p class="d-docsite--paragraph">The visual symbols of the dialpad and Ai are combined to represent the relationship between businesses and customers with Dialpad as the connective tissue.</p>
  </div>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/logo--sample-01.jpg" alt="">
  </figure>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/logo--sample-02.jpg" alt="">
  </figure>
  <figure class="d-bar-500 d-of-hidden">
    <img src="/assets/images/logo--sample-03.png" alt="">
  </figure>
</dt-stack>
</div></template>


